import { useEffect, useRef, useState } from 'react';
import BottomFixedModal from '@src/components/common/bottomFixedModal/BottomFixedModal';
import './signInWeddingContract.scss';
import { useSelector } from 'react-redux';
import { weddingHallContract } from '@src/@slice/weddingHallContractSlice';

const SignInWeddingContract = ({isShow,completeSign,closeModal}) => {

    const finalAgree = useSelector(weddingHallContract).data.agreement.finalAgree;
    const [step, setStep] = useState(0);
    const [inputValue1, setInputValue1] = useState(finalAgree ? '확인' : '');
    const [inputValue2, setInputValue2] = useState(finalAgree ? '동의' : '');
    
    const inputRef1 = useRef(null);
    const inputRef2 = useRef(null);


    //인풋태그 포커스
    useEffect(() => {
        if (step === 0 && inputRef1.current) {
            inputRef1.current.focus();
        } else if (step === 1 && inputRef2.current) {
            inputRef2.current.focus();
        }
    }, [step]);

    const changeValue = (e, step) => {
        step === 0 ?  setInputValue1(e.target.value) : setInputValue2(e.target.value)
    }

    const activeNextBtn = () => {
        if((step === 0 && inputValue1 === '확인') || (step > 0 && inputValue2 === '동의')){
            return 'active'
        }else {
            return 'btn-disabled'
        }
    }

    return (
        <BottomFixedModal  
            isShow={isShow} title="" className='contract-sign-sheet-wrap'
            hideModal={() => {
                setStep(0);
                setInputValue1('');
                setInputValue2('');
                closeModal();
            }}>
        {isShow && 
            <>
                <div className='contract-sign-sheet'>
                    <h2>{`계약을 진행하기 위해서\n전자서명이 필요합니다.`}</h2>
                    <p className='notice-box'>
                        계약 내용 및 계약 규정을 {` `}
                        <strong className={`${step > 0 ? 'complete' : ''}`}>확인</strong>
                        하였으며, 위 내용에 {` `}
                        <strong>동의</strong>
                        합니다.
                    </p>
                    <div className="form-block">
                        <span className="title">{step === 0? '확인을' : '동의를'} 입력해주세요.</span>
                        <div className="form-content">
                            <input
                                type="text"
                                ref={step === 0 ? inputRef1 : inputRef2}
                                className={`input-text input-full`}
                                value={step === 0? inputValue1: inputValue2}
                                placeholder={step === 0? '확인' : '동의'}
                                onChange={(e)=>changeValue(e, step)}
                        />
                    </div>
                    <button 
                        className={`btn btn-full btn-red500 ${activeNextBtn()}`} 
                        onClick={()=> {step === 0? setStep(step + 1) : completeSign()}}
                        disabled={activeNextBtn() === 'btn-disabled'}
                        >
                            {step === 0? '다음' : '완료'}
                    </button>
                </div>       
                </div>
            </>
        }
        </BottomFixedModal>
    );
};

export default SignInWeddingContract;